
import CookieLaw from 'vue-cookie-law'

export default {
  name: 'MatomoConsentBanner',
  components: {
    CookieLaw,
  },
  data() {
    return {
      isMatomoActive: false,
    }
  },
  mounted() {
    this.isMatomoActive = Boolean(window._paq)
  },
  methods: {
    callMatomo(method) {
      if (this.$matomo && typeof this.$matomo[method] === 'function') {
        this.$matomo[method]()
        return
      }
      window._paq.push([method])
    },
    rememberConsentGiven() {
      this.callMatomo('rememberConsentGiven')
    },
    forgetConsentGiven() {
      this.callMatomo('forgetConsentGiven')
    },
  },
}
